(() => {
  const init = (root) => {
    if (root.dataset.azReady === 'true') return;
    root.dataset.azReady = 'true';

    const search = root.querySelector('[data-az-search]');
    const clear = root.querySelector('[data-az-clear]');
    const items = Array.from(root.querySelectorAll('[data-az-item]'));
    const groups = Array.from(root.querySelectorAll('[data-az-group]'));
    const letterLinks = Array.from(root.querySelectorAll('[data-az-letter-link]'));
    const count = root.querySelector('[data-az-count]');
    const countLabel = root.querySelector('[data-az-count-label]');
    const empty = root.querySelector('[data-az-empty]');

    if (!search || !items.length) return;

    const filter = () => {
      const query = search.value.trim().toLowerCase();
      let visibleCount = 0;
      const visibleLetters = new Set();

      items.forEach((item) => {
        const matches = !query || item.dataset.azSearchValue.includes(query);
        item.hidden = !matches;
        if (matches) {
          visibleCount += 1;
          visibleLetters.add(item.dataset.azLetter);
        }
      });

      groups.forEach((group) => {
        const hasVisibleItems = visibleLetters.has(group.dataset.azLetter);
        group.hidden = !hasVisibleItems;
      });

      letterLinks.forEach((link) => {
        const unavailable = query && !visibleLetters.has(link.dataset.azLetterLink);
        link.classList.toggle('is-search-empty', Boolean(unavailable));
      });

      if (count) count.textContent = visibleCount;
      if (countLabel) countLabel.textContent = visibleCount === 1 ? root.dataset.itemLabel : root.dataset.itemsLabel;
      if (clear) clear.hidden = !query;
      if (empty) empty.hidden = visibleCount !== 0;
    };

    search.addEventListener('input', filter);
    clear?.addEventListener('click', () => {
      search.value = '';
      filter();
      search.focus();
    });

    filter();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-sf-trade-az]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
